import { DomainInitPayload, Order } from '@sxm-de/dev-kits/web-sdk/types';
import { MapClientSdkToWebSdk } from '@sxm-de/dev-kits/web-sdk/utils';

interface CreateOrderForSubscriptionChangeFnPayload {
    subscriptionId: string;
    offerId: string;
    flow: 'regular' | 'save';
    giftCardId: string;
}

export type CreateOrderForSubscriptionChangeFn = (
    payload: CreateOrderForSubscriptionChangeFnPayload,
) => Promise<Order>;

export function initCreateOrderForSubscriptionChangeFn({
    dependencies,
    state,
}: DomainInitPayload): CreateOrderForSubscriptionChangeFn {
    const { clientSdk } = dependencies;
    return async ({
        subscriptionId,
        offerId,
        flow,
        giftCardId,
    }: CreateOrderForSubscriptionChangeFnPayload) => {
        const { stripePaymentMethodId } = state;
        try {
            const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
                Awaited<ReturnType<typeof clientSdk.commerce.order.planSwitch>>,
                Order
            > = (order) => {
                return {
                    ...order,
                    subscriptionId: order.subscriptionId || '',
                    created: new Date(order.created),
                    charges: order.charges.map((charge) => {
                        return {
                            oneTimeCharge:
                                'oneTimeCharge' in charge &&
                                charge.oneTimeCharge
                                    ? {
                                          ...charge.oneTimeCharge,
                                          period: {
                                              start: new Date(
                                                  charge.oneTimeCharge.period
                                                      ?.start || '',
                                              ),
                                              end: new Date(
                                                  charge.oneTimeCharge.period
                                                      ?.end || '',
                                              ),
                                          },
                                          count: 0,
                                          lines: charge.oneTimeCharge.lines.map(
                                              (line) => {
                                                  return {
                                                      ...line,
                                                      taxes: {
                                                          total: line.taxes
                                                              ?.total || {
                                                              currency: {
                                                                  code: '',
                                                              },
                                                              value: 0,
                                                          },
                                                          breakdown:
                                                              line.taxes?.breakdown.map(
                                                                  (
                                                                      breakdown,
                                                                  ) => {
                                                                      return {
                                                                          ...breakdown,
                                                                          jurisdiction:
                                                                              breakdown.jurisdiction ||
                                                                              '',
                                                                          jurisdictionLevel:
                                                                              breakdown.jurisdictionLevel ||
                                                                              '',
                                                                          taxType:
                                                                              breakdown.taxType ||
                                                                              '',
                                                                          displayName:
                                                                              '',
                                                                      };
                                                                  },
                                                              ) || [],
                                                      },
                                                      fees: line.fees?.map(
                                                          (fee) => {
                                                              return {
                                                                  ...fee,
                                                              };
                                                          },
                                                      ),
                                                      total: line.total || {
                                                          value: 0,
                                                          currency: {
                                                              code: '',
                                                          },
                                                      },
                                                  };
                                              },
                                          ),
                                          billingPeriod:
                                              charge.oneTimeCharge
                                                  .billingPeriod || {},
                                          previousBalance: charge.oneTimeCharge
                                              .previousBalance || {
                                              value: 0,
                                              currency: { code: '' },
                                          },
                                          postPurchaseBalance: charge
                                              .oneTimeCharge
                                              .postPurchaseBalance || {
                                              value: 0,
                                              currency: { code: '' },
                                          },
                                          giftCardBalance:
                                              charge.oneTimeCharge
                                                  .giftCardBalance || null,
                                      }
                                    : undefined,
                            // repeatingCharge:
                            //     'repeatingCharge' in charge
                            //         ? {
                            //               ...charge.repeatingCharge,
                            //           }
                            //         : undefined,
                            // ongoingCharge:
                            //     'ongoingCharge' in charge
                            //         ? {
                            //               ...charge.ongoingCharge,
                            //           }
                            //         : undefined,
                            // zeroCharge:
                            //     'zeroCharge' in charge
                            //         ? {
                            //               ...charge.zeroCharge,
                            //           }
                            //         : undefined,
                        };
                    }),
                    offerId: order.offerId || '',
                };
            };
            const order = mapClientSdkToWebSdk(
                await clientSdk.commerce.order.planSwitch({
                    subscriptionId,
                    offerId,
                    ...(giftCardId && { giftCardId }),
                    ...(flow && { flow }),
                    ...(stripePaymentMethodId ? { stripePaymentMethodId } : {}),
                }),
            );
            // TODO: add analytics
            return order;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
